// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2tFOw","label":"Completed_label__3ZlYI"};